module.exports = __webpack_public_path__ + "static/media/page1_deer.42abc519.png";